<template>
    <h3>{{title}}</h3>
    <div class="stylesoption">
        <div class="row">
            <div class="col-sm" v-for="index in numeral_range">
                <designer-question-hardware-numeral :fabricator="fabricator"
                                                    v-model:target="target[index]"
                                                    :slab="slab"
                                                    :hardware-handle="hardwareHandle"
                                                    :hardware-colour="hardwareColour"
                                                    :title="'Numeral ' + (index + 1)"></designer-question-hardware-numeral>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareNumerals from "../DesignerQuestionHardwareNumerals.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareNumerals,
        ],
    }
</script>
